import { supabase } from "@/lib/supabaseClient";
import type {
  ApproveCompanyTimeAwayRequestInput,
  CompanyEmployeeRosterRow,
  CompanyTimeAwayQueueRow,
  RejectCompanyTimeAwayRequestInput,
} from "./mappers";
import { assertOk, toBoolean, type RpcResult } from "./mappers";

export async function listCompanyEmployeeRoster(
  companyId: string
): Promise<CompanyEmployeeRosterRow[]> {
  const res = (await supabase.rpc("list_company_employee_roster", {
    p_company_id: companyId,
  })) as RpcResult<CompanyEmployeeRosterRow[]>;

  return assertOk(res).map((row: any) => ({
    id: String(row.id),
    company_id: String(row.company_id),
    auth_user_id: row.auth_user_id == null ? null : String(row.auth_user_id),
    email: row.email == null ? null : String(row.email),
    custom_employee_id:
      row.custom_employee_id == null ? null : String(row.custom_employee_id),
    full_name: row.full_name == null ? null : String(row.full_name),
    first_name: row.first_name == null ? null : String(row.first_name),
    middle_names: row.middle_names == null ? null : String(row.middle_names),
    last_name: row.last_name == null ? null : String(row.last_name),
    is_active:
      row.is_active == null ? null : toBoolean(row.is_active),
    is_payroll_eligible:
      row.is_payroll_eligible == null ? null : toBoolean(row.is_payroll_eligible),
    is_management:
      row.is_management == null ? null : toBoolean(row.is_management),
  }));
}

export async function listCompanyTimeAwayQueue(
  companyId: string
): Promise<CompanyTimeAwayQueueRow[]> {
  const res = (await supabase.rpc("list_company_time_away_queue", {
    p_company_id: companyId,
  })) as RpcResult<CompanyTimeAwayQueueRow[]>;

  return assertOk(res).map((row: any) => ({
    id: String(row.id),
    employee_id: String(row.employee_id),
    employee_name:
      row.employee_name == null ? null : String(row.employee_name),
    employee_custom_id:
      row.employee_custom_id == null ? null : String(row.employee_custom_id),
    type: row.type == null ? null : String(row.type),
    start_date: row.start_date == null ? null : String(row.start_date),
    end_date: row.end_date == null ? null : String(row.end_date),
    status: row.status == null ? null : String(row.status),
    certification_state:
      row.certification_state == null ? null : String(row.certification_state),
    physical_original_required:
      row.physical_original_required == null
        ? null
        : toBoolean(row.physical_original_required),
    physical_original_status:
      row.physical_original_status == null
        ? null
        : String(row.physical_original_status),
    employee_note:
      row.employee_note == null ? null : String(row.employee_note),
    manager_feedback:
      row.manager_feedback == null ? null : String(row.manager_feedback),
    created_at: row.created_at == null ? null : String(row.created_at),
    requires_approval:
      row.requires_approval == null ? null : toBoolean(row.requires_approval),
    can_current_user_approve:
      row.can_current_user_approve == null
        ? null
        : toBoolean(row.can_current_user_approve),
  }));
}

export async function approveCompanyTimeAwayRequest(
  input: ApproveCompanyTimeAwayRequestInput
): Promise<string> {
  const res = (await supabase.rpc("approve_company_time_away_request", {
    p_company_id: input.companyId,
    p_absence_id: input.absenceId,
    p_manager_feedback: input.managerFeedback ?? null,
  })) as RpcResult<string>;

  return assertOk(res);
}

export async function rejectCompanyTimeAwayRequest(
  input: RejectCompanyTimeAwayRequestInput
): Promise<string> {
  const res = (await supabase.rpc("reject_company_time_away_request", {
    p_company_id: input.companyId,
    p_absence_id: input.absenceId,
    p_manager_feedback: input.managerFeedback,
  })) as RpcResult<string>;

  return assertOk(res);
}